import { mapActions, mapGetters } from 'vuex';
import ScQuickLinks from '@garmin/support-components/src/components/ScQuickLinks/index.vue';
import ScContentTextResults from '@garmin/support-components/src/components/ScContentTextResults/index.vue';
import ScPagination from '@garmin/support-components/src/components/ScPagination/index.vue';
import { fireUtagEvent } from '@garmin/support-analytics';
import TheSystemTopics from '../../components/the-system-topics/index.vue';
import TranslationsMixin from '../../mixins/translations';
import ResultsMixin from '../../mixins/results';
import SearchKeyword from '../../components/search-keyword/index.vue';
import TheIntroHero from '../../components/the-intro-hero/index.vue';
import * as QuickLinksConfig from '../../util/quickLinks';

export default {
  title() {
    return `${this.translations.commonSettings.generalSettings.pageTitle}`;
  },
  name: 'Home',
  mixins: [TranslationsMixin, ResultsMixin],
  components: {
    TheSystemTopics,
    ScQuickLinks,
    ScContentTextResults,
    ScPagination,
    SearchKeyword,
    TheIntroHero,
  },
  mounted() {
    this.resetFaqModuleState();

    if ((this.systemConfig || {}).topSolutionsTagName) {
      this.fetchContentResultsPag({
        to: this.$route,
        tags: [this.systemConfig.topSolutionsTagName, this.systemConfig.businessUnitTagName],
      });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    await this.fetchContentResultsPag({
      to,
      tags: [this.systemConfig.topSolutionsTagName, this.systemConfig.businessUnitTagName],
    });

    next();
  },
  beforeRouteLeave(to, from, next) {
    this.reset();
    next();
  },
  computed: {
    ...mapGetters('SSM/', ['locale', 'systemConfig']),
    ...mapGetters('SSM/content', [
      'subTopics',
      'topics',
      'hasTopics',
      'hasResults',
      'getTopicsTransformed',
      'contentResults',
    ]),
    quickLinksData() {
      return {
        accessibleNavLabel: QuickLinksConfig.quickLinksAccessibleNavLabel(this.translations),
        heading: QuickLinksConfig.quickLinksHeading(this.translations),
        image: QuickLinksConfig.quickLinksImage(this.translations),
        imageSet: QuickLinksConfig.quickLinksImagesArray(this.translations),
        lazyLoad: QuickLinksConfig.quickLinksLazyLoad,
        links: QuickLinksConfig.quickLinksLinks(this.translations),
      };
    },
    getInitialKeywordSearch() {
      return this.$route.query.keywordSearch || '';
    },
  },
  methods: {
    ...mapActions('SSM/content', [
      'reset',
      'fetchSubTopics',
      'fetchSystemTopics',
      'resetFaqModuleState',
      'fetchContentResults',
      'fetchContentVideoResults',
    ]),
    onSearchKeywordChange(keyword) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (keyword) query.keywordSearch = keyword;
      else delete query.keywordSearch;
      this.triggerAnalytics(keyword);

      this.$router.push({
        name: 'issuesView',
        query,
        params: {
          expandFilter: true,
          showTopics: false,
          scrollTo: '.sc__systems-issues__results',
        },
      });
    },
    triggerAnalytics(keyword) {
      const path = `${this.$route.params.path}`;
      fireUtagEvent({
        event_category: `${path[0].toUpperCase() + path.slice(1)} - Search`,
        event_action: 'Search',
        event_label: keyword,
      });
    },
  },
};
